export function sum(values) {
    return values.reduce((total, value) => total + value, 0);
}
export function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
